import apiClient from './client'

export interface SetupStatus {
  initialized: boolean
}

export interface SetupParams {
  username: string
  password: string
  confirmPassword: string
  displayName?: string
}

export async function getSetupStatus(): Promise<SetupStatus> {
  const response = await apiClient.get('/api/setup') as { status?: boolean }
  return {
    initialized: Boolean(response?.status),
  }
}

export async function initializeSystem(params: SetupParams): Promise<void> {
  await apiClient.post('/api/setup', params)
}
